function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "7",
  cy: "7",
  r: "6.708",
  fill: "#fff",
  stroke: "#F21E11",
  strokeWidth: ".583"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.625 4.375l-5.25 5.25M9.625 9.625l-5.25-5.25",
  stroke: "#F21E11",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));